const BLACKLIST = {
  GET_LIST: 'auth/internal-blacklist-list' as 'auth/internal-blacklist-list',
  GET_AUDIT_LIST: 'auth/internal-blacklist-audit-list' as 'auth/internal-blacklist-audit-list',
  DELETE: 'auth/internal-blacklist-delete' as 'auth/internal-blacklist-delete',
}

export default BLACKLIST
